/**
 * Teacher sign-in screen (docs/06-UI-SPEC.md §3).
 *
 * One centred card holding a single Google button. There is no email field and no
 * password field here or anywhere else in the product.
 */

import { GoogleMark } from '../assets/icons.js';
import { Logo } from '../assets/Logo.js';
import { useQueryParam } from '../router.js';

const SIGN_IN_URL = '/api/auth/google';

/**
 * Google's sign-in button.
 *
 * The colours below are Google's own brand values and are deliberately NOT design
 * tokens: docs/06-UI-SPEC.md §3 requires the official branding unmodified, so a
 * white-label rebrand must not recolour this button.
 */
function GoogleSignInButton() {
  return (
    <a
      href={SIGN_IN_URL}
      className="
        inline-flex h-touch items-center justify-center gap-3 rounded-md border
        px-4 text-base font-medium no-underline
        transition duration-fast ease-out hover:shadow-sm
      "
      style={{ background: '#FFFFFF', borderColor: '#747775', color: '#1F1F1F' }}
    >
      <GoogleMark size={18} />
      Sign in with Google
    </a>
  );
}

/** Shown when Google succeeded but the account is not on the teacher allowlist. */
function NotRegisteredCard() {
  return (
    <>
      <h1 className="text-xl font-semibold text-text-primary">This account isn&apos;t registered</h1>
      <p className="text-base text-text-secondary">
        Please contact your administrator to get access.
      </p>
      <a
        href={SIGN_IN_URL}
        className="
          inline-flex h-touch items-center justify-center rounded-md border border-border
          bg-surface px-4 text-base font-medium text-text-primary no-underline
          transition duration-fast ease-out hover:bg-surface-hover
        "
      >
        Try a different account
      </a>
    </>
  );
}

export function TeacherSignInPage() {
  const notRegistered = useQueryParam('error') === 'not-registered';

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-12 bg-surface-sunken p-6">
      <Logo size={48} />

      <div
        className="
          flex w-full max-w-[400px] flex-col items-center gap-6 rounded-xl
          bg-surface p-12 text-center shadow-lg
        "
      >
        {notRegistered ? <NotRegisteredCard /> : <GoogleSignInButton />}
      </div>
    </main>
  );
}
